import { Spacer, TabsBarLink } from '@porsche-code/kado-ui';
import { PHeading, PTabsBar } from '@porsche-design-system/components-react';
import {
  createFileRoute,
  Navigate,
  Outlet,
  useMatchRoute,
} from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';

import { RouteGuard } from '@/components';

export const Route = createFileRoute('/admin/ppn-masterdata-import')({
  component: () => {
    const matchRoute = useMatchRoute();

    return (
      <RouteGuard can="manage" a="PpnMasterdataImportStatus">
        {matchRoute({ to: '/admin/ppn-masterdata-import' }) ? (
          <Navigate to="/admin/ppn-masterdata-import/status" replace />
        ) : (
          <PpnMasterdataImport />
        )}
      </RouteGuard>
    );
  },
  beforeLoad: () => {
    return {
      breadcrumb: () => <Trans i18nKey="admin.ppnMasterdataImport.headline" />,
    };
  },
});

function PpnMasterdataImport() {
  const { t } = useTranslation();
  const matchRoute = useMatchRoute();

  const tabs = [
    {
      label: t('admin.ppnMasterdataImport.status'),
      routeId: '/admin/ppn-masterdata-import/status',
    },
    {
      label: t('admin.ppnMasterdataImport.movedOrganizations'),
      routeId: '/admin/ppn-masterdata-import/moved-organizations',
    },
  ];

  const activeTabIndex = tabs.findIndex((tab) =>
    matchRoute({ to: tab.routeId, fuzzy: true }),
  );

  return (
    <>
      <PHeading size="lg" aria-level={1} tag="h1">
        {t('admin.ppnMasterdataImport.headline')}
      </PHeading>
      <Spacer mb="md" />
      <PTabsBar size="medium" compact activeTabIndex={activeTabIndex}>
        {tabs.map((tab) => (
          <TabsBarLink key={`${tab.routeId}`} to={tab.routeId}>
            {tab.label}
          </TabsBarLink>
        ))}
      </PTabsBar>
      <Spacer mb="md" />
      <Outlet />
    </>
  );
}
